module.exports = __webpack_public_path__ + "img/receipt19.11167af1.png";